import type { FirebaseOptions } from "firebase/app";

/**
 * A configuração do Firebase do ambiente, separada de `lib/firebase.ts`.
 *
 * Existe à parte porque a página de entrada do aplicativo
 * (`entrar-com-google.html`) precisa dela sem levar junto o que
 * `lib/firebase.ts` inicializa ao ser importado: Firestore, Functions e
 * Storage, que a página não usa e que pesariam no celular do cliente.
 */
export const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Falhar aqui, no carregamento, é melhor que falhar na primeira consulta: sem
// isso o painel abre, mostra a tela de login e só quebra quando alguém tenta
// entrar, com um erro do SDK que não diz que faltou variável de ambiente.
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error(
    "Firebase não configurado. Copie .env.example para .env e preencha as variáveis VITE_FIREBASE_*.",
  );
}
